import clsx from 'clsx';

import { ShopTopBar } from './shop-top-bar';

interface VoucherLayoutProps {
	header?: string;
	headerRightContent?: React.ReactNode;
	showTopBar?: boolean;
	containerClassName?: string;
	children: React.ReactNode;
}

export const ShopLayout = ({ 
	header, 
	headerRightContent, 
	showTopBar = true,
	containerClassName,
	children 
}: VoucherLayoutProps) => {
	return (
		<div 
			className="shop-main reward-scroller"
			data-open="true"
		>
			{showTopBar ? (
				<ShopTopBar 
					header={header}
					rightContent={headerRightContent}
				/>
			) : null}

			<div className={clsx('reward-container reward-scroller', containerClassName)}>
				{children}
			</div>
		</div>
	);
};